import React from 'react';
import {Card,
        CardMedia,
        makeStyles,
        Typography,
        Button,
        Grid,
} from '@material-ui/core/';
import lineImg from '../Images/lines3.png';

const useStyles = makeStyles({
    root: {
        width: '100vw',
        height: '60vh',
    },
    btnStyle : {
        height: 60,
        width: 300,
    },
    pos: {
        marginBottom: 20,
    },
    shadow: {
        boxShadow: '0px -1px 5px 0px black',
        zIndex: 1,
    }
})

function PickADate() {
    const classes = useStyles();

    return(
        <Card className={classes.shadow}>
            <CardMedia className={classes.root} image={lineImg} >
                <Grid container direction='column' justify='center' alignItems='center' style={{ height: '100%' }}>

                    <Typography className={classes.pos} color='textPrimary' variant='h3' align='center' >
                        Vyberte si volný termín
                    </Typography>

                    <Button href='/calendar' className={classes.btnStyle} size='large' variant='contained' color='primary'>
                        Termíny
                    </Button>

                </Grid>
            </CardMedia>
        </Card>
    )
}

export default PickADate;